module.exports = __webpack_public_path__ + "img/infovac-france-logo.eef71be7.svg";